"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1868],{

/***/ 40261:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Common_Modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72651);
/* harmony import */ var _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86812);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25617);
/* harmony import */ var _components_DesignSystem_AtomicComponents_util__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(52388);
/* harmony import */ var src_redux_actions__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(96031);
/* harmony import */ var src_redux_actions__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(31024);
/* harmony import */ var src_redux_actions__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(66162);
/* harmony import */ var src_redux_actions__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(67936);
/* harmony import */ var _VariantRadioGroup__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16873);
/* harmony import */ var _utils_selectedVariantFromVariantList__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(82983);
/* harmony import */ var _utils_itemIndexFromCart__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(48670);
/* harmony import */ var _utils_routes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77326);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _Common_Toast__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(40804);
/* harmony import */ var _DesignSystem_AtomicComponents__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(38855);
/* harmony import */ var _DesignSystem_AtomicComponents_CartButton_CartButton_styles__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(51592);
/* harmony import */ var _assets_svgExports_MinusIcon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(82513);
/* harmony import */ var _assets_svgExports_PlusIcon__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(8886);
/* harmony import */ var _utils_getCustomCtaText__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(36623);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(13886);
/* harmony import */ var _utils_mutateVariantItemWithCartData__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(59186);
/* harmony import */ var _utils_LocalStorageHelper__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(44779);
/* harmony import */ var _utils_checkRenderEnv__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(6337);
/* harmony import */ var _hooks_useCartHandler__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(91240);

























var VariantModal = function(props) {
    var ref, ref1, ref2, ref3;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useDispatch */ .I0)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        variantIndex: -1,
        variantId: -1
    }), activeVariant = ref4[0], setActiveVariant = ref4[1];
    var ref5 = (0,_hooks_useCartHandler__WEBPACK_IMPORTED_MODULE_18__/* .useCartHandlers */ .u)(), handleIncreamentClick = ref5.handleIncreamentClick, handleDecreamentClick = ref5.handleDecreamentClick, handleSetProductData = ref5.handleSetProductData, handleSetState = ref5.handleSetState, onPersonalizeProductClick = ref5.onPersonalizeProductClick, handleSetProductCustomizationCount = ref5.handleSetProductCustomizationCount;
    /*
   state created to handle cart changes that are not saved.
   for eg, if user adds quantity of variant but does't save the change/ add to cart,
   then global cart data will not get changed
   */ var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({}), localCartData = ref6[0], setLocalCartData = ref6[1];
    var ref7 = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state.storeReducer.store;
    }), store_info = ref7.store_info, theme = ref7.theme, store_id = ref7.store_id;
    var ref8 = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return {
            userData: state.userReducer,
            storeInfo: state.storeReducer.store,
            cartData: state.cartReducer
        };
    }), userData = ref8.userData, storeInfo = ref8.storeInfo, cartData = ref8.cartData;
    var ref9 = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state.commonReducer;
    }), variantModal = ref9.variant.variantModal, detailedItem = ref9.detailedItem, productLoaderId = ref9.productLoaderId;
    /*
    below useEffect is for saving index and id of first available
    variant of the specific item
  */ (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (variantModal && detailedItem) {
            var ref;
            var activeVariantIndex = detailedItem === null || detailedItem === void 0 ? void 0 : (ref = detailedItem.variants) === null || ref === void 0 ? void 0 : ref.findIndex(function(el) {
                return el.available === 1 && el.status !== 2;
            });
            var ref1;
            setActiveVariant(function(state) {
                var ref, ref2;
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({}, state), {
                    variantIndex: activeVariantIndex,
                    variantId: (ref1 = detailedItem === null || detailedItem === void 0 ? void 0 : (ref = detailedItem.variants) === null || ref === void 0 ? void 0 : (ref2 = ref[activeVariantIndex]) === null || ref2 === void 0 ? void 0 : ref2.variant_id) !== null && ref1 !== void 0 ? ref1 : -1
                });
            });
            handleSetState === null || handleSetState === void 0 ? void 0 : handleSetState(activeVariantIndex);
            // store cartData in local state
            if (cartData) {
                setLocalCartData(cartData);
            }
        }
    }, [
        variantModal,
        detailedItem
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (variantModal && detailedItem === null) {
            dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_21__/* .fetchCatalogItemById */ .eP)({
                store_id: store_id,
                item_id: productLoaderId,
                src: "variant_modal"
            }, true));
        }
        if (variantModal === false) {
            setActiveVariant({
                variantIndex: -1,
                variantId: -1
            });
            if (document.getElementsByTagName("body")[0] && document.getElementsByTagName("body")[0].style) {
                document.getElementsByTagName("body")[0].style.overflowY = "scroll";
            }
        } else {
            if (document.getElementsByTagName("body")[0] && document.getElementsByTagName("body")[0].style) {
                document.getElementsByTagName("body")[0].style.overflowY = "hidden";
            }
        }
    }, [
        variantModal,
        detailedItem
    ]);
    var itemIndexInCart = (0,_utils_itemIndexFromCart__WEBPACK_IMPORTED_MODULE_22__/* .itemIndexFromCart */ .R)(localCartData, detailedItem);
    var onVariantSelect = function(selectedInd, item) {
        if (item.available) {
            setActiveVariant(function(state) {
                var ref;
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({}, state), {
                    variantIndex: selectedInd,
                    variantId: detailedItem === null || detailedItem === void 0 ? void 0 : (ref = detailedItem.variants) === null || ref === void 0 ? void 0 : ref[selectedInd].variant_id
                });
            });
            handleSetState(selectedInd);
        } else (0,_Common_Toast__WEBPACK_IMPORTED_MODULE_8__/* .toastNotifyInfo */ .lU)("Variant not available!");
    };
    var onClose = function() {
        dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_23__/* .setVariantModalVisibility */ .VZ)(false));
        dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_23__/* .saveDetailedItemById */ .VY)(null));
        dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_23__/* .saveProductLoaderId */ .XG)(null));
    };
    var onAddToCartBtnHandle = function() {
        if (activeVariant.variantIndex === -1) return;
        if (!getCombinedQuantityOfSelectedVariants()) {
            handleCart("add");
        }
        props.isRedirect && router.push((0,_utils_routes__WEBPACK_IMPORTED_MODULE_6__.getRoute)(_utils_routes__WEBPACK_IMPORTED_MODULE_6__.PATH.CART, store_info === null || store_info === void 0 ? void 0 : store_info.domain));
    };
    var handleCart = function(type) {
        var ref, ref1;
        if (type === "inc" && !qtyLessThanAvailQty()) {
            (0,_Common_Toast__WEBPACK_IMPORTED_MODULE_8__/* .toastNotifyInfo */ .lU)("No more units available for purchase");
            return;
        }
        dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_23__/* .saveProductLoaderId */ .XG)(detailedItem.id));
        dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_23__/* .saveDetailedItemById */ .VY)(detailedItem));
        var newCart = [];
        type = type === "add" || type === "inc" ? "inc" : "dec";
        newCart = (0,_utils_mutateVariantItemWithCartData__WEBPACK_IMPORTED_MODULE_15__/* .mutateVariantItemWithCartData */ .I)(type, detailedItem, detailedItem.variants[activeVariant.variantIndex], localCartData);
        setLocalCartData(newCart);
        dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_24__/* .saveCart */ .FP)(newCart));
        dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_25__/* .pushEventsLog */ .U)({
            event_name: "Cx_ATC",
            data: {
                store_id: storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id,
                domain: storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.store_info) === null || ref === void 0 ? void 0 : ref.domain,
                page: window.location.href,
                device: _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_3__/* .deviceWidth */ .o <= _utils_constants__WEBPACK_IMPORTED_MODULE_14__/* .MAX_MOBILE_WIDTH */ .Cf ? "Mobile" : "Desktop",
                cx_number: userData === null || userData === void 0 ? void 0 : (ref1 = userData.data) === null || ref1 === void 0 ? void 0 : ref1.phone
            }
        }));
    };
    // get sum of all quantity of selected variant
    var getCombinedQuantityOfSelectedVariants = function() {
        var ref, ref1, ref2;
        var sumVariantQuantity = 0;
        if (Object.keys(localCartData).length && (localCartData === null || localCartData === void 0 ? void 0 : (ref = localCartData.items) === null || ref === void 0 ? void 0 : (ref1 = ref[itemIndexInCart]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.variants_selected) === null || ref2 === void 0 ? void 0 : ref2.length)) {
            var ref3;
            sumVariantQuantity = (ref3 = localCartData === null || localCartData === void 0 ? void 0 : localCartData.items[itemIndexInCart]) === null || ref3 === void 0 ? void 0 : ref3.variants_selected.reduce(function(acc, curr) {
                return acc + curr.quantity;
            }, 0);
        }
        return sumVariantQuantity;
    };
    /**
   * utility function to get quantity and current item data of product
   * @return {*} obj
   */ var returnItemData = function() {
        var itemData = {
            quantity: 0,
            selectedItem: null
        };
        if (itemIndexInCart >= 0) {
            var ref, ref1, ref2;
            if (localCartData === null || localCartData === void 0 ? void 0 : (ref = localCartData.items) === null || ref === void 0 ? void 0 : (ref1 = ref[itemIndexInCart]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.variants_selected) === null || ref2 === void 0 ? void 0 : ref2.length) {
                var selectedVariant = (0,_utils_selectedVariantFromVariantList__WEBPACK_IMPORTED_MODULE_26__/* .selectedVariantFromVariantList */ .m)(localCartData, itemIndexInCart, activeVariant.variantId);
                var ref3;
                itemData = {
                    quantity: (ref3 = selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.quantity) !== null && ref3 !== void 0 ? ref3 : 0,
                    selectedItem: selectedVariant ? selectedVariant : null
                };
            } else {
                var ref4, ref5, ref6;
                itemData = {
                    quantity: localCartData === null || localCartData === void 0 ? void 0 : (ref4 = localCartData.items) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[itemIndexInCart]) === null || ref5 === void 0 ? void 0 : ref5.quantity,
                    selectedItem: localCartData === null || localCartData === void 0 ? void 0 : (ref6 = localCartData.items) === null || ref6 === void 0 ? void 0 : ref6[itemIndexInCart]
                };
            }
        }
        return itemData;
    };
    /**
   * Check if quantity is less than available qty
   * @return {*} boolean
   */ var qtyLessThanAvailQty = function() {
        var selectedItem = returnItemData().selectedItem;
        if (selectedItem && !!Object.keys(selectedItem).length) {
            // only work if available qty is not 0
            if (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.available_quantity) {
                return selectedItem.quantity < selectedItem.available_quantity;
            }
        }
        return true;
    };
    var LeftCartButton = function() {
        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_DesignSystem_AtomicComponents_CartButton_CartButton_styles__WEBPACK_IMPORTED_MODULE_10__/* .InteractionComponent */ .$1, {
            position: "left:14px;",
            width: "30px",
            onClick: function(e) {
                e.stopPropagation();
                if (detailedItem === null || detailedItem === void 0 ? void 0 : detailedItem.product_personalization) {
                    _utils_checkRenderEnv__WEBPACK_IMPORTED_MODULE_17__/* .IS_CLIENT */ .kc && _utils_LocalStorageHelper__WEBPACK_IMPORTED_MODULE_16__/* ["default"].add */ .Z.add("activeVariantId", activeVariant.variantId);
                    handleSetProductData(detailedItem);
                    handleDecreamentClick("dec", detailedItem);
                    dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_23__/* .setVariantModalVisibility */ .VZ)(false));
                } else {
                    handleCart("dec");
                }
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_svgExports_MinusIcon__WEBPACK_IMPORTED_MODULE_11__/* .MinusIcon */ .V, {})
        });
    };
    var RightCartButton = function() {
        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_DesignSystem_AtomicComponents_CartButton_CartButton_styles__WEBPACK_IMPORTED_MODULE_10__/* .InteractionComponent */ .$1, {
            position: "right:14px;",
            width: "30px",
            onClick: function(e) {
                e.stopPropagation();
                if (detailedItem === null || detailedItem === void 0 ? void 0 : detailedItem.product_personalization) {
                    _utils_checkRenderEnv__WEBPACK_IMPORTED_MODULE_17__/* .IS_CLIENT */ .kc && _utils_LocalStorageHelper__WEBPACK_IMPORTED_MODULE_16__/* ["default"].add */ .Z.add("activeVariantId", activeVariant.variantId);
                    handleSetProductData(detailedItem);
                    handleIncreamentClick("inc", detailedItem);
                    dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_23__/* .setVariantModalVisibility */ .VZ)(false));
                } else {
                    handleCart("inc");
                }
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: qtyLessThanAvailQty() ? "o-100" : "o-20",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_svgExports_PlusIcon__WEBPACK_IMPORTED_MODULE_12__/* .PlusIcon */ .p, {})
            })
        });
    };
    var handlePPAddToCart = function() {
        _utils_checkRenderEnv__WEBPACK_IMPORTED_MODULE_17__/* .IS_CLIENT */ .kc && _utils_LocalStorageHelper__WEBPACK_IMPORTED_MODULE_16__/* ["default"].add */ .Z.add("activeVariantId", activeVariant.variantId);
        dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_23__/* .setVariantModalVisibility */ .VZ)(false));
        handleSetProductData(detailedItem);
        handleSetProductCustomizationCount(detailedItem);
        onPersonalizeProductClick();
    };
    return variantModal && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_Modal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        visible: variantModal,
        customStyles: {
            paddingLeft: 0,
            paddingRight: 0,
            maxWidth: _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_3__/* .deviceWidth */ .o <= 766 ? "100%" : 480
        },
        animation: "slideUp",
        className: "bottom-modal",
        onClose: onClose,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "variantModal",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "variantModal-section",
                    style: {
                        border: "none"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "variantModal-closeicon",
                            onClick: onClose,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                loading: "lazy",
                                src: "https://cdn.dotpe.in/longtail/themes/8073865/9sE359Sh.webp",
                                alt: "cancel"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            children: "Choose One"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "variant-list",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_VariantRadioGroup__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        itemLowQty: detailedItem === null || detailedItem === void 0 ? void 0 : detailedItem.low_quantity,
                        itemList: (detailedItem === null || detailedItem === void 0 ? void 0 : detailedItem.variants) || [],
                        activeIdx: activeVariant.variantIndex,
                        onChange: onVariantSelect
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "add-to-cart flex justify-between",
                    children: itemIndexInCart === -1 && (detailedItem === null || detailedItem === void 0 ? void 0 : detailedItem.product_personalization) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "tw-flex tw-w-full tw-cursor-pointer tw-justify-center tw-py-[0.875rem] tw-text-[15px]",
                        onClick: handlePPAddToCart,
                        style: {
                            backgroundColor: theme === null || theme === void 0 ? void 0 : (ref = theme.colors) === null || ref === void 0 ? void 0 : ref.primary_color,
                            borderRadius: theme ? "".concat((0,_components_DesignSystem_AtomicComponents_util__WEBPACK_IMPORTED_MODULE_27__/* .roundnessCalculator */ .M)(theme.roundness)) : "8px",
                            color: "#FFFF"
                        },
                        children: (storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.theme) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.cta_config) === null || ref2 === void 0 ? void 0 : ref2.pdp_personalized_cta) || "Personalise and buy"
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "w-100 mr1 flex justify-center left-0",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_DesignSystem_AtomicComponents__WEBPACK_IMPORTED_MODULE_9__/* .CartButton */ .WE, {
                                    leftButton: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LeftCartButton, {}),
                                    rightButton: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RightCartButton, {}),
                                    fontSize: "15",
                                    roundness: theme === null || theme === void 0 ? void 0 : theme.roundness,
                                    onChange: function(type) {
                                        (detailedItem === null || detailedItem === void 0 ? void 0 : detailedItem.product_personalization) ? handlePPAddToCart() : handleCart(type);
                                    },
                                    // sending null to handle 0 quantity issue during render
                                    quantity: returnItemData().quantity,
                                    px: "5px",
                                    py: "14px",
                                    label: "Add to Cart",
                                    borderColor: "#00000000",
                                    style: {
                                        justifyContent: "center",
                                        width: _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_3__/* .deviceWidth */ .o > 540 ? "75%" : "100%"
                                    },
                                    wrapperClasses: "tw-w-full"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "w-100 ml1 right-0",
                                children: !getCombinedQuantityOfSelectedVariants() ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    className: "pointer",
                                    style: {
                                        backgroundColor: "".concat(theme ? theme === null || theme === void 0 ? void 0 : (ref3 = theme.colors) === null || ref3 === void 0 ? void 0 : ref3.primary_color : "#EA5151"),
                                        borderRadius: "".concat(theme ? "".concat((0,_components_DesignSystem_AtomicComponents_util__WEBPACK_IMPORTED_MODULE_27__/* .roundnessCalculator */ .M)(theme === null || theme === void 0 ? void 0 : theme.roundness)) : "8px"),
                                        opacity: "1"
                                    },
                                    onClick: onAddToCartBtnHandle,
                                    children: (0,_utils_getCustomCtaText__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)("buy_now_cta")
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    className: "pointer",
                                    style: {
                                        backgroundColor: "#369d00",
                                        borderRadius: "".concat(theme ? "".concat((0,_components_DesignSystem_AtomicComponents_util__WEBPACK_IMPORTED_MODULE_27__/* .roundnessCalculator */ .M)(theme === null || theme === void 0 ? void 0 : theme.roundness)) : "8px"),
                                        opacity: "1"
                                    },
                                    onClick: function() {
                                        dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_23__/* .setVariantModalVisibility */ .VZ)(false));
                                        router.push((0,_utils_routes__WEBPACK_IMPORTED_MODULE_6__.getRoute)(_utils_routes__WEBPACK_IMPORTED_MODULE_6__.PATH.CART, store_info === null || store_info === void 0 ? void 0 : store_info.domain));
                                    },
                                    children: "Go to Cart"
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (VariantModal);


/***/ }),

/***/ 82983:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ selectedVariantFromVariantList; }
/* harmony export */ });
/**
 * get variant from list if selected variants in cart data
 * @param {*} cartData
 * @param {*} itemIndexInCart
 * @param {*} selectedVariantId
 * @return {*} selectedVariant
 */ var selectedVariantFromVariantList = function(cartData, itemIndexInCart, selectedVariantId) {
    if (cartData && itemIndexInCart > -1) {
        var ref, ref1;
        return cartData === null || cartData === void 0 ? void 0 : (ref = cartData.items) === null || ref === void 0 ? void 0 : (ref1 = ref[itemIndexInCart]) === null || ref1 === void 0 ? void 0 : ref1.variants_selected.find(function(variant) {
            return variant.variant_id === selectedVariantId;
        });
    }
    return 0;
};


/***/ })

}]);